import {
  getVerificationActionId,
  VerificationActionId,
} from 'components/organisms/SettingsViews/Peppol/helpers';
import useVerifications from 'hooks/useVerifications';
import useUserPeppolIntegration from './useUserPeppolIntegration';
import { IntegrationsStatusEnum } from 'types/integrations';

type Options = {
  enabled?: boolean;
};

const useDoesPeppolVerificationRequiresAction = (options?: Options) => {
  const verificationsQuery = useVerifications({ enabled: options?.enabled });
  const integrationQuery = useUserPeppolIntegration({
    enabled: options?.enabled,
  });

  if (options?.enabled === false) return false;

  const integrationStatus = integrationQuery.data?.status;

  const companyStatus = verificationsQuery.data?.company?.status;
  const identityStatus = verificationsQuery.data?.identity?.status;

  const integrationPendingUserAction =
    integrationStatus === IntegrationsStatusEnum.verification_required;

  if (!integrationPendingUserAction) return false;

  const actionId = getVerificationActionId({
    companyStatus,
    identityStatus,
  });

  const verificationPendingUserAction =
    actionId === VerificationActionId.Start ||
    actionId === VerificationActionId.Rejected ||
    actionId === VerificationActionId.Resubmission;

  return verificationPendingUserAction;
};

export default useDoesPeppolVerificationRequiresAction;
